module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('header', {
    staticClass: "header-wrap-sticky",
    staticStyle: {
      "display": "none",
      "background": "#000000",
      "color": "#ffffff",
      "border-bottom": "none"
    },
    attrs: {
      "id": "mainStickyHeader"
    }
  }, [_c('div', {
    staticClass: "row header-wrap-inner",
    staticStyle: {
      "border-bottom": "none",
      "margin": "0"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "-20em"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    staticStyle: {
      "background": "#000000 !important",
      "color": "#ffffff"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "14px"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("  "), _c('b', [_vm._v(_vm._s(_vm.header_name))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "width": "100%",
      "margin-left": "-2em",
      "margin-top": "-3em",
      "background-color": "#000000",
      "height": "auto",
      "padding": "2em",
      "text-align": "center",
      "color": "#ffffff"
    }
  }, [_c('h3', {}, [_vm._v(_vm._s(_vm.sellpoint.business_name)), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("C A T A L O G")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "row"
  }, [(!_vm.has_sellpoints) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _c('div', {}, [_c('div', {
    staticClass: "row page-top-header sticky-tab",
    staticStyle: {
      "display": "none",
      "width": "100% !important",
      "margin": "0 !important",
      "margin-top": "-0.3em !important",
      "background": "#000000 !important",
      "color": "#ffffff"
    },
    attrs: {
      "id": "pageStickyHeaderMAIN"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "90% !important"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business')
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {}, [_c('p', {
    staticStyle: {
      "text-transform": "capitalize",
      "margin-top": "0.8em",
      "margin-left": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "7% !important"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "color": "#ffffff",
      "margin-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'manageBusiness', _vm.sellpoint, '/account/business/settings')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "16px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide",
    staticStyle: {
      "clear": "both",
      "margin-top": "-1.5em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', '', _vm.sellpoint, '/account/business')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _vm._v("Business")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business/products')
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusiness', _vm.sellpoint, '/account/business/categories')
      }
    }
  }, [_vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessOrders', _vm.sellpoint, '/account/business/orders')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'manageBusiness', _vm.sellpoint, '/account/business/settings')
      }
    }
  }, [_vm._v("Settings")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel"
  }, [((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "page-top-header sticky-tab",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pageStickyHeaderMAIN"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticClass: "col-xs-2 header-left",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "headTagBack"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bolder"
    }
  }, [_vm._v("STORE")]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-transform": "uppercase",
      "margin-top": "-0.8em"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide",
    staticStyle: {
      "margin-top": "-1.5em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business/product')
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusiness', _vm.sellpoint, '/account/business/categories')
      }
    }
  }, [_vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessOrders', _vm.sellpoint, '/account/business/orders')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'manageBusiness', _vm.sellpoint, '/account/business/settings')
      }
    }
  }, [_vm._v("Settings")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-after-stick",
    staticStyle: {
      "padding": "0.7em"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(2)]) : _c('div', [(this.$route.path != '/account/business') ? _c('div', [_c('router-view')], 1) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card detail-card",
    staticStyle: {
      "padding": "0.3em"
    }
  }, [(Object.keys(_vm.menu_tab_inner_view).length == 0) ? _c('div', {
    staticClass: "card row"
  }, [_c('div', {
    staticClass: "col-xs-12 row00"
  }, [_c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_c('b', [_vm._v("Name")]), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_c('b', [_vm._v("Phone numbers and Emails")]), _c('br'), _vm._v("\r\n                              " + _vm._s(_vm.sellpoint.business_phones) + " "), (_vm.sellpoint.business_emails != '') ? _c('span', [_vm._v(", " + _vm._s(_vm.sellpoint.business_emails))]) : _vm._e()]), _vm._v(" "), ((_vm.sellpoint.business_phones == '') && (_vm.sellpoint.business_emails == '')) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Not yet added")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewBusinessProfile', '', '')
      }
    }
  }, [_vm._v("See Business Profile")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.viewBusinessProfile) ? _c('div', {
    staticClass: "card"
  }, [_c('h6', [_vm._v("Business Details")]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.menu_tab_inner_view = {}
      }
    }
  }, [_vm._v("<< Back")]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  }), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(5), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(6), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_profile))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(7), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_address))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(8), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_emails))])]), _vm._v(" "), _c('div', {
    staticClass: "card card-strip"
  }, [_c('p', [_vm._m(9), _c('br'), _vm._v(_vm._s(_vm.sellpoint.business_phones))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('editBusinessProfile', '', '')
      }
    }
  }, [_vm._v("Edit Business Profile")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'manageBusiness', _vm.sellpoint, '/account/business/settings')
      }
    }
  }, [_vm._v("Shop Settings")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_vm._v("Shop Banner Image")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn btn sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Banner Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeBannerImage($event, 'business_banner_image')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_vm._v("Shop Profile Image")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.sellpoint.business_brand_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn btn sp-button-02",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Profile Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeBannerImage($event, 'business_brand_image')
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.editBusinessProfile) ? _c('div', [_c('hr'), _vm._v(" "), _c('h6', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Brief")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Emails")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('');
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])])])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-fix-nav",
    staticStyle: {
      "z-index": "7",
      "height": "4em",
      "background": "#000000",
      "bottom": "0em",
      "border-top": "#afadad 1px solid",
      "padding-top": "1.5em"
    }
  }, [_c('div', {
    staticClass: "tab-slide",
    staticStyle: {
      "clear": "both",
      "margin-top": "-1.5em"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', '', _vm.sellpoint, '/account/business')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('br'), _vm._v("Business")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusinessProducts', _vm.sellpoint, '/account/business/products')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _c('br'), _vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'viewBusiness', _vm.sellpoint, '/account/business/categories')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _c('br'), _vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessOrders', _vm.sellpoint, '/account/business/orders')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _c('br'), _vm._v("Orders")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('div', {
    staticClass: "card card-row"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("You do not have a store yet")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "href": "/account/business/newbusiness"
    }
  }, [_vm._v("Register Businesses and create Sellpoints")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 row01"
  }, [_c('h6', {
    staticClass: "col-xs-12"
  }, [_vm._v("Quick Links")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-basket"
  })]), _vm._v(" "), _c('p', [_vm._v("About Shop Information")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('p', [_vm._v("Add Product to Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Generate Transfer Receipt")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })]), _vm._v(" "), _c('p', [_vm._v("Set Bank & Payment Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-cubes"
  })]), _vm._v(" "), _c('p', [_vm._v("Manage Shipping")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('p', [_vm._v("Set Rewards & Commissions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 row01"
  }, [_c('h6', {
    staticClass: "col-xs-12"
  }, [_vm._v("How my shop appears to people")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-basket"
  })]), _vm._v(" "), _c('p', [_vm._v("Shop Banner Photo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('p', [_vm._v("Shop Display or Logo Photo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Products and thier photos")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })]), _vm._v(" "), _c('p', [_vm._v("Category List of my shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-cubes"
  })]), _vm._v(" "), _c('p', [_vm._v("See Posts & Updates")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('p', [_vm._v("Promos & Discounts")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Name ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("About ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Emails ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("Phone ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-866af560"}!./src/pages/Account/Sellpoint/Template/template.html
// module id = 568
// module chunks = 0